const images = {
  logo: require('../images/logo.png'),
  testainglogo: require('../images/testailogo.png')
};

export default images;
